import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";

import {BsCalendar4Week} from "react-icons/bs";
import Barcode from 'react-barcode';

import {LiaEyeSolid} from "react-icons/lia";
import {IoMdCheckmarkCircleOutline} from "react-icons/io";
import {FaCarBattery, FaCubes, FaInfo} from "react-icons/fa";
import {BiAlarm} from "react-icons/bi";

function SBOrder() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [order, setOrder] = React.useState([]);
    const [code, setCode] = React.useState('');
    const [type, setType] = React.useState(0);
    const [pallet, setPallet] = React.useState('');

    const [result, setResult] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [description, setDescription] = React.useState('');



    React.useEffect(() => {

        const params = {
            'processFor' : 'Sales',
            'returned' : 1
        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);

                setIsLoaded(true);
                setTimeout(() => {
                    setIsLoaded(true);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                       // window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                       // window.history.back()
                    },400)
                }
            });


    }, [id , result]);




    const onAddButtonClick =  () => {
        setIsLoaded(false);
        const request = {
            order_id: id,
            'processFor' : 'Vendors',
            code,
            pallet,
            type
        }
        API.updateBOrder( request , id )
            .then((response) => {
                toast.success(response.message);
                const params = {
                    'processFor' : 'Vendors',
                    'returned' : 1
                }

                API.getOrder(params , id)
                    .then((response) => {
                        setOrder(response.data);

                        setCode('')
                        setPallet('')
                        setIsLoaded(true);

                    })
            })
            .catch((error) => {
                setIsLoaded(true);
                toast.error(error.response.data.message)
            });
    }
    const onStatusButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            'order_id': id,
            'status_id' : statusId,
            description,
            'processFor' : 'Sales',
            'calc_battery_count' : 1
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/sb-orders/');
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }


    return (
        <React.Fragment>
            <Header/>

            <Navbar page="sborders" public="1"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش برگشت از فروش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد یکتای درخواست:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <BiAlarm />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            سفارش اصلی
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2"
                                        >
                                            <span
                                                onClick={
                                                    () => {
                                                        navigate(`/orders/${order?.original_order_id}`)
                                                    }
                                                }
                                                role='button'
                                                className='text-primary'
                                            >
                                                 {order.original_order_id}
                                            </span>

                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <BsCalendar4Week />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.date}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <FaCubes />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تعداد باتری ثبت شده
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.battery_qty}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <FaInfo />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            توضیحات
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.public_description}
                                        </div>
                                    </div>
                                    {
                                        order?.last_status?.id === 1 &&
                                        <div className="row card bg-secondary-subtle">

                                            <div className="col-12 border-bottom pt-4 text-center fw-bold text-small-2 pb-2 mb-3 text-success">
                                                افزودن باتری به درخواست
                                            </div>
                                            <div className="col-12">

                                                <div className="">
                                                    <div className="card-body py-4">
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <div className="form-floating mb-3">
                                                                    <input type="number"
                                                                           className="form-control text-center"
                                                                           id="floatingInput" placeholder="کد"
                                                                           autoFocus={true}
                                                                           value={code}
                                                                           onChange={(val) => {
                                                                               setCode(val.target.value)
                                                                           }}
                                                                    />
                                                                    <label htmlFor="floatingInput">کد باتری</label>
                                                                </div>
                                                            </div>


                                                            <div className="col-md-5">
                                                                <div className="form-floating mb-3">
                                                                    <input type="number"
                                                                           className="form-control text-center"
                                                                           id="floatingInput" placeholder="کد"
                                                                           autoFocus={true}
                                                                           value={pallet}
                                                                           onChange={(val) => {
                                                                               setPallet(val.target.value)
                                                                           }}
                                                                    />
                                                                    <label htmlFor="floatingInput">کد پالت</label>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                &nbsp;
                                                            </div>
                                                            <div className="col-md-5">
                                                                &nbsp;
                                                            </div>
                                                            <div className="col-md-2 p-2  mt-3  ">
                                                                <div
                                                                    className="form-check form-switch text-danger bg-danger-subtle  rounded">
                                                                    <input className="form-check-input"
                                                                           type="checkbox" role="switch"
                                                                           id='confirm'
                                                                           checked={type}
                                                                           onChange={(val) => {
                                                                               if (val.target.checked) {
                                                                                   setType(1)
                                                                               } else {
                                                                                   setType(0)
                                                                               }
                                                                           }}

                                                                    />
                                                                    <label className="form-check-label fw-bold text-danger"
                                                                           htmlFor='confirm'
                                                                           role="button">
                                                                        {pallet.length > 2 ?
                                                                            'باتری های پالت خراب است' :
                                                                            'باتری خراب است'


                                                                        }
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-2 p-2  mt-3  ">
                                                                <div
                                                                    className="form-check form-switch text-success bg-success-subtle  rounded">
                                                                    <input className="form-check-input"
                                                                           type="checkbox" role="switch"
                                                                           id='confirm'
                                                                           checked={!type}
                                                                           onChange={(val) => {
                                                                               if (val.target.checked) {
                                                                                   setType(0)
                                                                               } else {
                                                                                   setType(1)
                                                                               }
                                                                           }}

                                                                    />
                                                                    <label className="form-check-label fw-bold text-success"
                                                                           htmlFor='confirm'
                                                                           role="button">
                                                                        {pallet.length > 2 ?
                                                                            'باتری های پالت سالم است' :
                                                                            'باتری سالم است'


                                                                        }
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-3 pt-2">
                                                                <button className="btn btn-success w-100 py-2"
                                                                        onClick={onAddButtonClick}
                                                                >
                                                                    افزودن به درخواست
                                                                    <FaCarBattery className='float-start mt-1'/>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    }


                                    <div className="row mx-2 mt-2">
                                        <div className="col-md-12 mt-4">


                                            <div className="form-floating">
                                    <textarea className="form-control" placeholder="توضیحات" id="floatingTextarea"
                                              value={description}
                                              onChange={
                                                  (event) => {
                                                      setDescription(event.target.value)
                                                  }
                                              }
                                    >

                                    </textarea>
                                                <label htmlFor="floatingTextarea" className="right-0">
                                                    توضیحات سفارش
                                                </label>
                                            </div>

                                        </div>
                                        <div className="col-12">
                                            {
                                                order?.last_status?.id === 1 &&
                                                <div className="row">
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-outline-danger text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(16)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            کنسل کردن درخواست
                                                        </button>
                                                    </div>

                                                    <div className="col-md-6 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-warning text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(7)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            ارسال به واحد فروش کارخانه جهت تایید
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                order?.last_status?.id === 13 &&
                                                <div className="row">
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-outline-danger text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(16)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            کنسل کردن درخواست
                                                        </button>
                                                    </div>

                                                    <div className="col-md-6 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-success text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(14)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            ارسال باتری ها به کارخانه
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                order?.last_status?.id === 14 &&
                                                <div className="row">
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>

                                                    <div className="col-md-6 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-danger text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(13)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            انصراف از ارسال
                                                        </button>
                                                    </div>
                                                </div>
                                            }

                                        </div>


                                    </div>



                                    <div className="row mx-2 mb-3 pb-2 list-battery">
                                        <div className="col-12 text-small-2 border-bottom pb-2 text-primary">
                                            باتری ها
                                        </div>
                                        <div className="col-12">
                                            <div className='my-4'>
                                                 <span className='alert alert-primary fade show text-small-2 py-1' role='button'
                                                       onClick={() => navigate(`/order-batteries/${id}`)}
                                                 >
                                                گزارش وضعیت باتری های این سفارش
                                                     &nbsp;
                                                     <LiaEyeSolid />
                                            </span>
                                            </div>
                                            <div className="row">
                                                {
                                                    order?.details?.batteries_list?.map(bt => {
                                                        return (
                                                            <div className="col-3  px-3 mt-3" key={bt.code}>
                                                                <div className='bg-white rounded p-1 '

                                                                     onClick={() => {
                                                                         setCode(bt)
                                                                     }}
                                                                >
                                                                    <Barcode value={bt.code} height={20} width={1} fontSize={12}/>
                                                                    {bt.type > 0 &&
                                                                        <span className='bg-danger text-white mt-2 text-center text-small-3 badge rounded-pill'>
                                                                             خراب
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">تاریخچه وضعیت های درخواست</h5>
                                    <div className="row">
                                        {
                                            order?.history?.map(stat => {
                                                return (
                                                    <div className='col-12 mt-2 bg-light text-small-1  p-2'>
                                                        <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                    style={{color: stat.status.color}}
                                                        />
                                                        سفارش در تاریخ:
                                                        &nbsp;
                                                        {stat.date}
                                                        &nbsp;
                                                        توسط
                                                        &nbsp;
                                                        {stat.user.name}
                                                        &nbsp;
                                                        {stat.user.surname}
                                                        &nbsp;
                                                        در وضعیت
                                                        &nbsp;
                                                        <span className='fw-bold' style={{color: stat.status.color}}>
                                                            {stat.status.title}
                                                        </span>

                                                        &nbsp;
                                                        قرار گرفت.

                                                        <div className='fw-bold text-muted me-4 text-small-2 mt-3'>
                                                            {stat.description?.length > 2 ? stat.description : ''}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default SBOrder;